///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { CcmIntervalEnum, ExportLinkConfigDTO } from '../../generated/shared-types.model';
import { validateGateWayBySubnetwork, validateIpBySubnetwork } from '../../shared/directives/validation-functions/subnetwork-validation';

export class ExportLinkConfig implements ExportLinkConfigDTO {
    defaultGateway: string;
    engineId: string;
    ipLessTu: boolean;
    managementVid: number;
    mng_uname: string;
    mng_upass: string;
    pasw: string;
    rapsVid: number;
    snmpIP: string;
    snmpVersion: number;
    ssid: string;
    ssidpw: string;
    startIp: string;
    startVid: number;
    subnetMask: number;
    timezone: string;
    trap: string;
    udpPort: number;
    vidPerRing: number;
    ccmInterval: CcmIntervalEnum;

    constructor(data: any) {
        if (data) {
            this.assignValues(data);
        }
    }

    public checkIPValidityBySubnetwork(ip: string): boolean {
        if (ip && this.subnetMask && this.startIp) {
            return validateIpBySubnetwork(ip, this.startIp, this.subnetMask);
        }
        return true;
    }

    public checkGateWayValidityBySubnetwork(): boolean {
        if (this.defaultGateway && this.subnetMask && this.startIp) {
            return validateGateWayBySubnetwork(this.defaultGateway, this.startIp, this.subnetMask);
        }
        return true;
    }

    private assignValues(data: any): void {
        this.defaultGateway = data.defaultGateway ?? '10.0.0.1';
        this.engineId = data.engineId;
        this.ipLessTu = data.ipLessTu ?? true;
        this.managementVid = data.managementVid;
        this.mng_uname = data.mng_uname ?? 'admin';
        this.mng_upass = data.mng_upass ?? 'admin';
        this.pasw = data.pasw;
        this.rapsVid = data.rapsVid;
        this.snmpIP = data.snmpIP;
        this.snmpVersion = data.snmpVersion;
        this.ssid = data.ssid ?? 'MultiHaul';
        this.ssidpw = data.ssidpw ?? 'MultiHaul';
        this.startIp = data.startIp ?? '10.0.0.2';
        this.startVid = data.startVid;
        this.subnetMask = data.subnetMask ?? 24;
        this.timezone = data.timezone;
        this.trap = data.trap;
        this.udpPort = data.udpPort;
        this.vidPerRing = data.vidPerRing;
        this.ccmInterval = data.ccmInterval ?? CcmIntervalEnum._100MS;
    }
}
